module.exports = __webpack_public_path__ + "media/images/visa-logo-df5fcfcb03ac918e8a6222c0e32ed3ea.png";